import { Link } from 'react-router-dom';
import { LogoBlock, LogoText } from './style';
import { FC } from 'react';

type LogoProps = {
  brandName?: string;
}

export const Logo: FC<LogoProps> = ({
  brandName
}) => {
	return (
		<Link to="/">
      {brandName?.trim?.() ? 
      <LogoBlock role="logo">
        <span>Slotby x</span> {brandName}
      </LogoBlock>
      : <LogoText role="logo">SlotBy</LogoText>}
		</Link>
	);
};
